import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { AuthService, FeaturesService } from '@core/services';

import { TenantEnum, UserServiceCategory } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-filter-content',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule],
  templateUrl: './filter-content.component.html',
  styleUrls: ['./filter-content.component.scss'],
})
export class FilterContentComponent {
  features = inject(FeaturesService);
  deviceService = inject(DeviceDetectorService);
  private authService = inject(AuthService);
  private router = inject(Router);

  @Input() top: boolean;
  @Input() activeTab: Partial<UserServiceCategory>;
  @Input() tabs: Array<Partial<UserServiceCategory>>;

  @Output() onSelect = new EventEmitter<Partial<UserServiceCategory>>();

  public onSelectItem(filter) {
    this.onSelect.emit(filter);
  }

  public get isPageWithPadding() {
    return this.router.url.indexOf('favorites') > -1 || this.router.url.indexOf('profile') > -1;
  }

  public isMeVersion() {
    return this.features.tenant === TenantEnum.onclass_me;
  }

  public get isAuthenticated() {
    return this.authService.isAuthenticated;
  }

  public trackByFn(index) {
    return index;
  }
}
